<template lang="pug">
  WtButton.make-an-entry(@click.native="openModal") Add New Entry
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
const MakeAnEntryModal = () =>
  import(
    /* webpackChunkName: "MakeAnEntryModal" */ "@@/Members/MakeAnEntry/MakeAnEntryModal"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "MakeAnEntry",

  components: {
    WtButton,
    MakeAnEntryModal
  },

  mixins: [dateUtilityMixin],

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("members", [
      "makeAnEntryJournal",
      "makeAnEntryJournalLoading"
    ])
  },

  mounted() {
    this.unsubscribeActivitiesFetch = this.$store.subscribe(async mutation => {
      if (
        mutation.type === "members/SET_JOURNALS" &&
        !this.activitiesLoaded &&
        !this.activitiesLoading &&
        this.coreProgramMeta.converter
      ) {
        // ensure user is logged-in
        if (this.$auth.user()) {
          this.fetchActivities(this.$auth.user().programId);
        }
      }
    });
  },

  beforeDestroy() {
    this.unsubscribeActivitiesFetch();
  },

  methods: {
    ...mapActions("members", ["fetchActivities"]),

    openModal() {
      const props = {
        isMakeAnEntry: true
      };

      this.$buefy.modal.open({
        parent: this,
        props: props,
        component: MakeAnEntryModal,
        hasModalCard: true
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
